module.exports = __webpack_public_path__ + "media/swimming_in_the_pool.90441ca1.mp4";